import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { ImpersonateStore, ImpersonateState } from './impersonate.store';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ImpersonateQuery extends Query<ImpersonateState> {
    constructor(protected store: ImpersonateStore) {
        super(store);
    }

    get activeImpersonation() {
        return !!this.getValue().decodedToken;
    }

    /** Observable for impersonated user - emits when token is updated */
    selectImpersonatedUser$ = this.select('decodedToken');

    /** Observable for impersonated user name - emits when token is updated */
    userName$ = this.select((state) => state.decodedToken?.user_name);

    /** Observable for impersonated user - emits when token is updated */
    userRoles$ = this.select((state) => state.decodedToken?.realm_access?.roles);

    /** Observable for impersonated user scopes - emits when user scopes change */
    userScopes$ = this.select((state) => state.decodedToken?.scope).pipe(
        map((scopeString) => scopeString?.split(' ')),
        shareReplay(1)
    );

    /** get current user scopes for impersonated user */
    get userScopes() {
        return this.getValue().decodedToken?.scope.split(' ');
    }

    /** get current user roles for impersonated user */
    get userRoles() {
        return this.getValue().decodedToken?.realm_access.roles;
    }

    /** Observable for impersonated user id - emits when token is updated */
    selectImpersonatedUserId$ = this.select((state) => state.decodedToken?.userId);

    /** Observable for token of impersonated user - emits when token is updated */
    token$ = this.select((state) => state.token?.access_token);

    get refresh_token() {
        return this.getValue().token?.refresh_token;
    }
}
